'use client';

import useSWRImmutable from 'swr/immutable';

import { fetcherSS } from '@/modules/api';
import { License } from '@/store/commonStore/types';

interface IInfoProjectData {
  license: License;
  availableReferralSystem: boolean;
}

export const useInfoProject = () => {
  const { data, error, isLoading } = useSWRImmutable<IInfoProjectData>(
    '/info/project',
    fetcherSS,
    { revalidateOnMount: false }
  );

  return {
    data,
    isLoading,
    isError: error,
  };
};
